var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React, { useRef, useLayoutEffect, useState } from 'react';
import cls from 'classnames';
import { useScroll } from '@byted/hooks';
import styles from './index.module.scss';

const Header = ({
  className,
  children,
  isPreventScrollEvt = false,
  onColorChange,
  onBgColorChange
}) => {
  const [headerStyle, setHeaderStyle] = useState({
    blur: false,
    style: {
      backgroundColor: '',
      color: ''
    }
  });
  const {
    offset
  } = useScroll(typeof window !== 'undefined' ? window : null)[1];
  const domMapRef = useRef({
    list: []
  });

  const init = () => {
    domMapRef.current = {
      list: []
    };
    document.querySelectorAll('[data-scroll]').forEach(dom => {
      var _a;

      const {
        offsetTop
      } = dom;
      const rect = dom.getBoundingClientRect();

      if (rect.height === 0) {
        return;
      }

      const cmpStyle = window.getComputedStyle(dom, null);
      const bgColor = cmpStyle.backgroundColor;
      const rgba = (((_a = /^rgba?\((.*?)\)$/.exec(bgColor)) === null || _a === void 0 ? void 0 : _a[1]) || '0,0,0,0').trim().split(/,\s*/);

      if (rgba[3] === '0') {
        rgba[0] = '255';
        rgba[1] = '255';
        rgba[2] = '255';
      }

      rgba[3] = '0.7';
      domMapRef.current.list.push(offsetTop);
      domMapRef.current[offsetTop] = {
        color: cmpStyle.color,
        backgroundColor: `rgba(${rgba.join(',')})`
      };
    });
    domMapRef.current.list.sort((a, b) => a - b);

    if (window.scrollY) {
      document.body.scrollTop += 1;
    }
  };

  useLayoutEffect(() => {
    init();
  }, [headerStyle.blur, offset.y]);
  useLayoutEffect(() => {
    const _a = domMapRef.current,
          {
      list
    } = _a,
          domMap = __rest(_a, ["list"]);

    let blur = false;
    let style = {
      backgroundColor: '',
      color: ''
    };
    let i = 0;

    while (list[i] !== undefined && offset.y > list[i]) {
      blur = true;
      style = Object.assign({}, domMap[list[i]]);
      i++;
    }

    if (!isPreventScrollEvt) {
      setHeaderStyle({
        blur,
        style
      });
      onColorChange === null || onColorChange === void 0 ? void 0 : onColorChange(style.color);
      onBgColorChange === null || onBgColorChange === void 0 ? void 0 : onBgColorChange(style.backgroundColor);
    }
  }, [offset.y, isPreventScrollEvt]);
  return /*#__PURE__*/React.createElement("header", {
    className: cls(styles.container, className, {
      [styles.blur]: headerStyle.blur
    }),
    style: headerStyle.style
  }, children);
};

export default Header;